export default {
  MuiPaper: {
    defaultProps: {
      elevation: 1,
    },
  },
}
